import { render, staticRenderFns } from "./PopupAddNewEmployee.vue?vue&type=template&id=033e28e4&scoped=true&"
import script from "./PopupAddNewEmployee.vue?vue&type=script&lang=js&"
export * from "./PopupAddNewEmployee.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddNewEmployee.vue?vue&type=style&index=0&id=033e28e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033e28e4",
  null
  
)

export default component.exports